export enum EvalFeedbackStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Review = 'review',
  Pending = 'pending',
  Submitted = 'Submitted',
}
